import Request from "../request";
const request = new Request();

export class PaymentService {
  static list = async (
    goodName: string,
    method: number,
    sort: string,
    search: string,
    startDate: string,
    endDate: string,
    limit: number,
    page: number
  ) => {
    let params = "";

    if (goodName) {
      params += `goodName=${goodName}&`;
    }
    if (method) {
      params += `method=${method}&`;
    }
    if (sort) {
      params += `sort=${sort}&`;
    }
    if (search) {
      params += `search=${search}&`;
    }
    if (startDate) {
      params += `startDate=${startDate}&`;
    }
    if (endDate) {
      params += `endDate=${endDate}&`;
    }
    if (limit) {
      params += `limit=${limit}&`;
    }
    if (page) {
      params += `page=${page}&`;
    }

    const { data } = await request.get(
      "/admin/payment/history" + (params ? "?" + params.slice(0, -1) : "")
    );

    return data.data;
  };

  static detail = async (payId: string) => {
    const { data } = await request.get(`/admin/payment/history/${payId}`);
    return data.data;
  };

  static log = async (page: number) => {
    const { data } = await request.get(`/payment/log?page=${page}`);
    return data.data;
  };
}
